var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowSlider(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrows-repeat 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.6673 7.99985C14.6673 8.27485 14.4725 8.49986 14.2003 8.49986H2.94754L7.14455 13.1656C7.32821 13.3697 7.3132 13.6862 7.11121 13.8716C7.01558 13.9562 6.89496 14 6.77743 14C6.64307 14 6.50872 13.9453 6.41123 13.8359L1.46266 8.33579C1.29109 8.14535 1.29109 7.85422 1.46266 7.6639L6.41123 2.16376C6.59585 1.95869 6.90887 1.945 7.11053 2.12957C7.31252 2.31514 7.32752 2.63146 7.14387 2.83553L2.94754 7.49983H14.2003C14.4725 7.49983 14.6673 7.72484 14.6673 7.99985Z",
    fill: "#0D2E78"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSlider);
export default __webpack_public_path__ + "static/media/arrow-slider.845c3ec108092a6483d2b0bbf8bc2fe9.svg";
export { ForwardRef as ReactComponent };